import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Link, useNavigate, useLocation } from "react-router-dom";
import {
  MdAdminPanelSettings,
  MdDashboard,
  MdKeyboardArrowDown,
} from "react-icons/md";
import { FaAward } from "react-icons/fa";
import { IoSettingsOutline } from "react-icons/io5";
import { LuLogOut } from "react-icons/lu";
import { MdOutlineKeyboardDoubleArrowRight } from "react-icons/md";
import { FaUsers } from "react-icons/fa";
import { FaBookOpenReader, FaCoins } from "react-icons/fa6";
import { GiTakeMyMoney } from "react-icons/gi";
import { TbBrandStackshare } from "react-icons/tb";
import Logo from "../../../Images/logoIcon.png";
import { useAdminSession } from "../../../hooks/use-admin-session";
import {
  ADMIN_ROLES,
  canAccessRoles,
  clearSessionUser,
} from "../../../utils/adminSession";

const Sidebar = ({ isOpen: isSidebarOpen = false, onClose = () => {} }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const { currentUser } = useAdminSession();
  const [isOpen, setIsOpen] = useState(false);
  const [isOpen2, setIsOpen2] = useState(false);
  const [isOpen3, setIsOpen3] = useState(false);
  const [isOpen4, setIsOpen4] = useState(false);
  const [isOpen5, setIsOpen5] = useState(false);
  const [isOpen6, setIsOpen6] = useState(false);
  const [, i18n] = useTranslation();

  const toggleDropdown = () => {
    setIsOpen(!isOpen);
  };
  const toggleDropdown2 = () => {
    setIsOpen2(!isOpen2);
  };
  const toggleDropdown3 = () => {
    setIsOpen3(!isOpen3);
  };
  const toggleDropdown4 = () => {
    setIsOpen4(!isOpen4);
  };
  const toggleDropdown5 = () => {
    setIsOpen5(!isOpen5);
  };
  const toggleDropdown6 = () => {
    setIsOpen6(!isOpen6);
  };

  const changeLanguage = (lang) => {
    i18n.changeLanguage(lang);
  };

  const getLinkClass = (path) => {
    return location.pathname === path
      ? "flex items-center p-2 text-purple bg-purple-100 rounded-lg dark:text-purple-400 group"
      : "flex items-center p-2 text-gray-900 rounded-lg dark:text-black group";
  };
  const canAccessManagementModules = canAccessRoles(currentUser, [
    ADMIN_ROLES.SUPER_ADMIN,
    ADMIN_ROLES.ADMIN
  ]);

  useEffect(() => {
    onClose();
  }, [location.pathname, onClose]);

  return (
    <>
      <aside
        id="sidebar-multi-level-sidebar"
        className={`fixed bottom-0 left-0 top-16 z-40 w-72 transform transition-transform duration-300 ease-in-out lg:w-64 ${
          isSidebarOpen ? "translate-x-0" : "-translate-x-full lg:translate-x-0"
        }`}
        aria-label="Sidebar"
      >
        <div className="h-full overflow-y-auto bg-white py-4 shadow-2xl">
          <button
            onClick={onClose}
            className="absolute right-2 top-2 rounded-full p-2 text-gray-500 hover:bg-gray-200 lg:hidden"
            aria-label="Close navigation menu"
          >
            <svg
              className="w-6 h-6"
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M6 18L18 6M6 6l12 12"
              />
                {/* Logo in the center */}
                                   <div className="hidden sm:block text-2xl font-bold">
                                     <a href="/" className="flex items-center gap-1">
                                       <img
                                         className="w-14 h-14 object-contain"
                                         src={Logo}
                                         alt="Adhyayi Logo"
                                       />
                       
                                       <span className="text-bgBlue font-agrandir tracking-[2px] text-3xl">
                                         Adhyayi
                                       </span>
                                     </a>
                                   </div>
            </svg>
          </button>
          <ul className="space-y-2 font-medium font-oswald font-bold p-4">
            <li>
              <Link to="/dash/home" className={getLinkClass("/dash/home")}>
                <MdDashboard className="w-7 h-7 text-bgBlue transition duration-75 dark:text-gray-400 group-hover:text-gray-900 dark:group-hover:text-black" />
                <span className="ms-3 font-semibold">Home</span>
              </Link>
            </li>

            <hr />
            <li onClick={toggleDropdown}>
              <div
                className={`flex items-center justify-between p-2 rounded-lg cursor-pointer ${
                  isOpen ? "bg-gray-100" : ""
                }`}
              >
                <div className="flex items-center">
                  <FaUsers className="w-7 h-7 text-bgBlue transition duration-75 dark:text-gray-400 group-hover:text-gray-900 dark:group-hover:text-black" />
                  <span className="ms-3  font-semibold">User Controls</span>
                </div>
                <MdKeyboardArrowDown className="text-end" size={24} />
              </div>
              <ul
                id="dropdown-example"
                className={`space-y-2 font-medium flex flex-col  mt-2 text-end ${isOpen ? "" : "hidden"}`}
              >
                {/* <Link to="/dash/demo-user">
                  <li
                    className="flex items-center  w-full pl-5  text-bgBlue font-bold   cursor-pointer"
                    onClick={() => changeLanguage("hi")}
                  >
                    <MdOutlineKeyboardDoubleArrowRight
                      className="text-purple mr-2"
                      size={25}
                    />{" "}
                    New Users
                  </li>
                </Link> */}
                <Link to="/dash/active-user">
                  <li
                    className="flex items-center  w-full pl-5   text-bgBlue font-bold   cursor-pointer"
                    onClick={() => changeLanguage("hi")}
                  >
                    <MdOutlineKeyboardDoubleArrowRight
                      className="text-purple mr-2"
                      size={25}
                    />{" "}
                    Users
                  </li>
                </Link>
                <Link to="/dash/daily-user">
                  <li
                    className="flex items-center  w-full pl-5  text-bgBlue font-bold   cursor-pointer"
                    onClick={() => changeLanguage("hi")}
                  >
                    <MdOutlineKeyboardDoubleArrowRight
                      className="text-purple mr-2"
                      size={25}
                    />{" "}
                    Daily Users
                  </li>
                </Link>
                <Link to="/dash/onHold-user">
                  <li
                    className="flex items-center  w-full pl-5  text-bgBlue font-bold   cursor-pointer"
                    onClick={() => changeLanguage("hi")}
                  >
                    <MdOutlineKeyboardDoubleArrowRight
                      className="text-purple mr-2"
                      size={25}
                    />{" "}
                    Hold Users
                  </li>
                </Link>
                <Link to="/dash/KYC-user">
                  <li
                    className="flex items-center  w-full pl-5  text-bgBlue font-bold   cursor-pointer"
                    onClick={() => changeLanguage("hi")}
                  >
                    <MdOutlineKeyboardDoubleArrowRight
                      className="text-purple mr-2"
                      size={25}
                    />{" "}
                    KYC Users
                  </li>
                </Link>
              </ul>
            </li>
            <hr />
            <li onClick={toggleDropdown2}>
              <div
                className={`flex items-center justify-between p-2 rounded-lg cursor-pointer ${
                  isOpen2 ? "bg-gray-100" : ""
                }`}
              >
                <div className="flex items-center">
                  <FaBookOpenReader className="w-7 h-7 text-bgBlue transition duration-75 dark:text-gray-400 group-hover:text-gray-900 dark:group-hover:text-black" />
                  <span className="ms-3  font-semibold">Course Controls</span>
                </div>
                <MdKeyboardArrowDown className="text-end" size={24} />
              </div>
              <ul
                id="dropdown-example"
                className={`space-y-2 font-medium flex flex-col  mt-2 text-end ${isOpen2 ? "" : "hidden"}`}
              >
                <Link to="/dash/view-course">
                  <li
                    className="flex items-center  w-full pl-5  text-bgBlue font-bold   cursor-pointer"
                    onClick={() => changeLanguage("hi")}
                  >
                    <MdOutlineKeyboardDoubleArrowRight
                      className="text-purple mr-2"
                      size={25}
                    />{" "}
                    View Course
                  </li>
                </Link>
                <Link to="/dash/create-course">
                  <li
                    className="flex items-center  w-full pl-5   text-bgBlue font-bold   cursor-pointer"
                    onClick={() => changeLanguage("hi")}
                  >
                    <MdOutlineKeyboardDoubleArrowRight
                      className="text-purple mr-2"
                      size={25}
                    />{" "}
                    Create Course
                  </li>
                </Link>
                <Link to="/dash/create-lecture">
                  <li
                    className="flex items-center  w-full pl-5   text-bgBlue font-bold   cursor-pointer"
                    onClick={() => changeLanguage("hi")}
                  >
                    <MdOutlineKeyboardDoubleArrowRight
                      className="text-purple mr-2"
                      size={25}
                    />{" "}
                    Create Lecture
                  </li>
                </Link>
                <Link to="/dash/addExam">
                  <li
                    className="flex items-center  w-full pl-5   text-bgBlue font-bold   cursor-pointer"
                    onClick={() => changeLanguage("hi")}
                  >
                    <MdOutlineKeyboardDoubleArrowRight
                      className="text-purple mr-2"
                      size={25}
                    />{" "}
                    Create Exam
                  </li>
                </Link>
              </ul>
            </li>
            <hr />
            <li onClick={toggleDropdown4}>
              <div
                className={`flex items-center justify-between p-2 rounded-lg cursor-pointer ${
                  isOpen4 ? "bg-gray-100" : ""
                }`}
              >
                <div className="flex items-center">
                  <FaAward className="w-7 h-7 text-bgBlue transition duration-75 dark:text-gray-400 group-hover:text-gray-900 dark:group-hover:text-black" />
                  <span className="ms-3  font-semibold">Contest Controls</span>
                </div>
                <MdKeyboardArrowDown className="text-end" size={24} />
              </div>
              <ul
                id="dropdown-example"
                className={`space-y-2 font-medium flex flex-col  mt-2 text-end ${isOpen4 ? "" : "hidden"}`}
              >
                <Link to="/dash/view-contest">
                  <li
                    className="flex items-center  w-full pl-5  text-bgBlue font-bold   cursor-pointer"
                    onClick={() => changeLanguage("hi")}
                  >
                    <MdOutlineKeyboardDoubleArrowRight
                      className="text-purple mr-2"
                      size={25}
                    />{" "}
                    View Contest
                  </li>
                </Link>
                <Link to="/dash/add-contest">
                  <li
                    className="flex items-center  w-full pl-5   text-bgBlue font-bold   cursor-pointer"
                    onClick={() => changeLanguage("hi")}
                  >
                    <MdOutlineKeyboardDoubleArrowRight
                      className="text-purple mr-2"
                      size={25}
                    />{" "}
                    Add Contest
                  </li>
                </Link>
                <Link to="/dash/contest-users">
                  <li
                    className="flex items-center  w-full pl-5   text-bgBlue font-bold   cursor-pointer"
                    onClick={() => changeLanguage("hi")}
                  >
                    <MdOutlineKeyboardDoubleArrowRight
                      className="text-purple mr-2"
                      size={25}
                    />{" "}
                    Contest Users
                  </li>
                </Link>
              </ul>
            </li>
            <hr />
            <li>
              <Link
                to="/dash/leader-board"
                className={getLinkClass("/dash/leader-board")}
              >
                <FaAward className="w-7 h-7 text-bgBlue transition duration-75 dark:text-gray-400 group-hover:text-gray-900 dark:group-hover:text-black" />
                <span className="ms-3 font-semibold">Leader Board</span>
              </Link>
            </li>
            <hr/>
            <li onClick={toggleDropdown3}>
              <div
                className={`flex items-center justify-between p-2  rounded-lg cursor-pointer ${
                  isOpen3 ? "bg-gray-100" : ""
                }`}
              >
                <div className="flex items-center gap-0.5">
                  <GiTakeMyMoney className="w-7 h-7 text-bgBlue transition duration-75 dark:text-gray-400 group-hover:text-gray-900 dark:group-hover:text-black" />
                  <span className="  font-semibold">Payment Controls</span>
                </div>
                <MdKeyboardArrowDown className="text-end" size={24} />
              </div>
              <ul
                id="dropdown-example"
                className={`space-y-2 font-medium flex flex-col  mt-2 text-end ${isOpen3 ? "" : "hidden"}`}
              >
                <Link to="/dash/upi-orders">
                  <li
                    className="flex items-center  w-full pl-5  text-bgBlue font-bold   cursor-pointer"
                    onClick={() => changeLanguage("hi")}
                  >
                    <MdOutlineKeyboardDoubleArrowRight
                      className="text-purple mr-2"
                      size={25}
                    />{" "}
                    UPI Orders
                  </li>
                </Link>
                <Link to="/dash/recharge-orders">
                  <li
                    className="flex items-center  w-full pl-5   text-bgBlue font-bold   cursor-pointer"
                    onClick={() => changeLanguage("hi")}
                  >
                    <MdOutlineKeyboardDoubleArrowRight
                      className="text-purple mr-2"
                      size={25}
                    />{" "}
                    Recharge Orders
                  </li>
                </Link>
                <Link to="/dash/payment-setting">
                <li
                  className="flex items-center  w-full pl-5  text-bgBlue font-bold   cursor-pointer"
                  onClick={() => changeLanguage("hi")}
                >
                  <MdOutlineKeyboardDoubleArrowRight className="text-purple mr-2" size={25}/> {" "}
                  Payment setting
                </li>
                </Link>
                <Link to="/dash/unified-withdrawals">
                <li
                  className="flex items-center  w-full pl-5  text-bgBlue font-bold   cursor-pointer"
                  onClick={() => changeLanguage("hi")}
                >
                  <MdOutlineKeyboardDoubleArrowRight className="text-purple mr-2" size={25}/> {" "}
                  Unified Payment
                </li>
                </Link>


              </ul>
            </li>
            <hr />
            {/*           
            <li>
              <Link to="/dash/plan" className={getLinkClass("/dash/plan")}>
                <IoNewspaperOutline className="w-7 h-7 text-bgBlue transition duration-75 dark:text-gray-400 group-hover:text-gray-900 dark:group-hover:text-black" />
                <span className="ms-3  font-semibold">Course</span>
              </Link>
            </li>
            <hr /> */}
            {/* <li>
              <Link to="/dash/contest" className={getLinkClass("/dash/contest")}>
                <FaAward className="w-7 h-7 text-bgBlue transition duration-75 dark:text-gray-400 group-hover:text-gray-900 dark:group-hover:text-black" />
                <span className="ms-3  font-semibold">Contest</span>
              </Link>
            </li>
            <hr /> */}

            <li onClick={toggleDropdown5}>
              <div
                className={`flex items-center justify-between p-2 rounded-lg cursor-pointer ${
                  isOpen5 ? "bg-gray-100" : ""
                }`}
              >
                <div className="flex items-center">
                  <TbBrandStackshare className="w-7 h-7 text-bgBlue transition duration-75 dark:text-gray-400 group-hover:text-gray-900 dark:group-hover:text-black" />
                  <span className="ms-3  font-semibold">Referral Controls</span>
                </div>
                <MdKeyboardArrowDown className="text-end" size={24} />
              </div>
              <ul
                className={`space-y-2 font-medium flex flex-col  mt-2 text-end ${isOpen5 ? "" : "hidden"}`}
              >
                <Link to="/dash/referral-dashboard">
                  <li className="flex items-center  w-full pl-5  text-bgBlue font-bold   cursor-pointer">
                    <MdOutlineKeyboardDoubleArrowRight className="text-purple mr-2" size={25} />{" "}
                    Dashboard
                  </li>
                </Link>
                <Link to="/dash/referral-list">
                  <li className="flex items-center  w-full pl-5   text-bgBlue font-bold   cursor-pointer">
                    <MdOutlineKeyboardDoubleArrowRight className="text-purple mr-2" size={25} />{" "}
                    Active Referrals
                  </li>
                </Link>
                <Link to="/dash/all-users-referral">
                  <li className="flex items-center  w-full pl-5   text-bgBlue font-bold   cursor-pointer">
                    <MdOutlineKeyboardDoubleArrowRight className="text-purple mr-2" size={25} />{" "}
                    All User Referrals
                  </li>
                </Link>
                <Link to="/dash/referral-partner">
                  <li className="flex items-center  w-full pl-5   text-bgBlue font-bold   cursor-pointer">
                    <MdOutlineKeyboardDoubleArrowRight className="text-purple mr-2" size={25} />{" "}
                    Referrals Partners
                  </li>
                </Link>
                <Link to="/dash/referral-config">
                  <li className="flex items-center  w-full pl-5  text-bgBlue font-bold   cursor-pointer">
                    <MdOutlineKeyboardDoubleArrowRight className="text-purple mr-2" size={25} />{" "}
                    Settings
                  </li>
                </Link>
              </ul>
            </li>
            <hr />
            {canAccessManagementModules && (
              <>
              
                <li onClick={toggleDropdown6}>
                  <div
                    className={`flex items-center justify-between p-2 rounded-lg cursor-pointer ${
                      isOpen6 ? "bg-gray-100" : ""
                    }`}
                  >
                    <div className="flex items-center">
                      <MdAdminPanelSettings className="w-7 h-7 text-bgBlue transition duration-75 dark:text-gray-400 group-hover:text-gray-900 dark:group-hover:text-black" />
                      <span className="ms-3 font-semibold">Institute</span>
                    </div>
                    <MdKeyboardArrowDown className="text-end" size={24} />
                  </div>
                  <ul
                    className={`space-y-2 font-medium flex flex-col mt-2 text-left ${isOpen6 ? "" : "hidden"}`}
                  >
                    <Link to="/dash/admin-management">
                      <li className="flex items-center w-full pl-5 text-bgBlue font-bold cursor-pointer">
                        <MdOutlineKeyboardDoubleArrowRight
                          className="text-purple mr-2"
                          size={25}
                        />{" "}
                        Institute Admin
                      </li>
                    </Link>
                    <Link to="/dash/whiteLabel-admin-management">
                      <li className="flex items-center w-full pl-5 text-bgBlue font-bold cursor-pointer">
                        <MdOutlineKeyboardDoubleArrowRight
                          className="text-purple mr-2"
                          size={25}
                        />{" "}
                        WhiteLabel Admin
                      </li>
                    </Link>
                    <Link to="/dash/feature-management">
                      <li className="flex items-center w-full pl-5 text-bgBlue font-bold cursor-pointer">
                        <MdOutlineKeyboardDoubleArrowRight
                          className="text-purple mr-2 shrink-0"
                          size={25}
                        />
                        <span className="text-left leading-tight">
                          Feature Managementfile uplo
                        </span>
                      </li>
                    </Link>
                    <Link to="/dash/institute-withdrawal-requests">
                      <li className="flex items-center w-full pl-5 text-bgBlue font-bold cursor-pointer">
                        <MdOutlineKeyboardDoubleArrowRight
                          className="text-purple mr-2 shrink-0"
                          size={25}
                        />
                        <span className="text-left leading-tight">
                          Withdrawal Requests
                        </span>
                      </li>
                    </Link>
                    <Link to="/dash/institute-payments">
                      <li className="flex items-center w-full pl-5 text-bgBlue font-bold cursor-pointer">
                        <MdOutlineKeyboardDoubleArrowRight className="text-purple mr-2 shrink-0" size={25} />
                        <span className="text-left leading-tight">Institute Payment</span>
                      </li>
                    </Link>
                  </ul>
                </li>
              </>
              
            )}
              <hr />
            <li>
              <Link
                to="/dash/app-controls"
                className={getLinkClass("/dash/app-controls")}
              >
                <IoSettingsOutline className="w-7 h-7 text-bgBlue transition duration-75 dark:text-gray-400 group-hover:text-gray-900 dark:group-hover:text-black" />
                <span className="ms-3 font-semibold">App Controls</span>
              </Link>
            </li>
            <hr/>
            
            <li>
              <Link
                to="/dash/coin-transaction"
                className={getLinkClass("/dash/coin-transaction")}
              >
                <FaCoins className="w-7 h-7 text-bgBlue transition duration-75 dark:text-gray-400 group-hover:text-gray-900 dark:group-hover:text-black" />
                <span className="ms-3 font-semibold">Coin Transactions</span>
              </Link>
            </li>
            {/* <li>
              <Link
                to="/dash/live-chat"
                className={getLinkClass("/dash/live-chat")}
              >
                <FaComments className="w-7 h-7 text-bgBlue transition duration-75 dark:text-gray-400 group-hover:text-gray-900 dark:group-hover:text-black" />
                <span className="ms-3 font-semibold">Chat</span>
              </Link>
            </li>
            <hr /> */}
            <li
              onClick={() => {
                localStorage.removeItem("token");
                clearSessionUser();
                navigate("/login");
              }}
            >
              <Link className={getLinkClass("/logout")}>
                <LuLogOut className="w-7 h-7 text-bgBlue transition duration-75 dark:text-gray-400 group-hover:text-gray-900 dark:group-hover:text-black" />
                <span className="ms-3  font-semibold">Logout</span>
              </Link>
            </li>
            <hr />
          </ul>
        </div>
      </aside>

    </>
  );
};

export default Sidebar;
